/** @jsxImportSource @emotion/react */
"use client";

import { type Interpolation } from "@emotion/react";
import { useTranslations } from "@i18n/next";
import {
  IconButton,
  InfoIcon,
  numericPercentages,
  spacing,
  useDialog,
} from "@packages/ui";

const iconStyles: Interpolation = {
  padding: spacing.xs,
};

const modalContentStyles: Interpolation = {
  bottom: "auto",
  top: numericPercentages[50],
  transform: "translate(-50%, -50%)",
};

export const StripeInfoDialog = () => {
  const t = useTranslations();

  const dialogStripeInfo = useDialog({
    description: () => t("giving_stripe_description"),
    showCloseButton: true,
    size: "m",
    title: () => t("giving_what_is_stripe"),
    modalProps: { contentCSS: [modalContentStyles] },
  });

  return (
    <IconButton
      asChild
      onClick={async (e) => {
        e.stopPropagation();
        await dialogStripeInfo.show();
      }}
      icon={<InfoIcon size={20} />}
      size="s"
      variant="transparentNeutral"
      css={iconStyles}
    >
      <span />
    </IconButton>
  );
};
